export default __webpack_public_path__ + "static/media/armadillo-pipe-guard.eaea93fe.glb";